<div
    class="wrap-row channel text channel-table-row"
    #channelWrap
    [ngClass]="{ 'setting-open': isSelectedChannel }"
    [class.disabled]="disabled"
>
    <div
        class="wrap-row-col-top channel"
        (click)="isSelectedChannel ? onCloseClickedEmit() : ''"
        [ngClass]="ngClass"
    >
        <div class="col-top-id">
            <span data-cy="channel-group-channel-list-channel-number-compact">
                {{ channel.opsData.tag }}
            </span>
        </div>
        <div
            data-cy="channel-group-channel-list-channel-name-compact"
            class="col-top-name"
        >
            {{ channel.opsData.name | uppercase }}
        </div>
        <div class="col-top-value">
            <div
                data-cy="channel-group-channel-list-channel-status-compact"
                class="status-container"
                alarmLevelColor
                [channel]="channel"
                [status]="status"
            >
                {{ statusString | translate }}
            </div>
        </div>
        <div
            data-cy="channel-group-channel-list-channel-value-with-unit-compact"
            *ngIf="!isDigital"
            class="col-top-value"
        >
            {{ getValueString() }}
            {{ measurementUnit }}
        </div>
    </div>
    <div
        class="wrap-row-col-detail channel"
        [ngClass]="isSelectedChannel ? 'hidden' : ''"
        [ngClass]="ngClass"
    >
        <div
            data-cy="channel-group-channel-list-channel-range-compact"
            class="wrap-row-col-detail-content"
            #range
        >
            <div class="col-range-content" *ngIf="!isDigital">
                <app-channel-alarm-range
                    *ngIf="!responsive.isXSmall() && !disabled"
                    [channel]="channel"
                    [value]="channelValue"
                    [status]="status"
                ></app-channel-alarm-range>
                <app-alarm-indicator
                    #indicator
                    *ngIf="responsive.isXSmall() && !disabled"
                    [channel]="channel"
                    [value]="channelValue"
                    [status]="status"
                    [statusString]="statusString"
                >
                </app-alarm-indicator>
            </div>
        </div>

        <div class="hr"></div>
        <div style="padding: 16px">
            <div class="col-setting-btn">
                <button
                    data-cy="channel-group-channel-list-settings-button-compact"
                    class="primary"
                    [class.disabled]="disabled"
                    (click)="onChannelSelect()"
                >
                    {{ "channel.button.setting" | translate }}
                </button>
            </div>
        </div>
    </div>
    <app-channel-settings-dropdown
        #ChannelSettingsDropDown
        *ngIf="isSelectedChannel"
        [hidden]="!isSelectedChannel"
        [isSelectedChannel]="isSelectedChannel"
        [channel]="channel"
        [value]="isSelectedChannel ? channelValue : ''"
        (onSubmit)="onSubmitEmit($event)"
        (onAdvancedSettings)="onAdvancedSettingsEmit($event)"
        (onCloseClicked)="onCloseClickedEmit()"
        (onDeleteAlarm)="onDeleteAlarmEmit($event)"
    ></app-channel-settings-dropdown>
</div>
